var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"complex-bg-gradient-blur-wrapper",style:({
		top: `${_vm.top}px`,
		left: `${_vm.left}px`,
		..._vm.styles,
	})},[(_vm.includeLeftBlobs)?[_c('div',{staticClass:"complex-bg-gradient-blur-circle-4"})]:_vm._e(),_c('div',{staticClass:"complex-bg-gradient-blur-circle-2"}),_c('div',{staticClass:"complex-bg-gradient-blur-circle-3"}),_c('div',{staticClass:"complex-bg-gradient-blur-circle-1-4"}),_c('div',{staticClass:"complex-bg-gradient-blur-circle-1-3"}),_c('div',{staticClass:"complex-bg-gradient-blur-circle-1"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }